import R from 'ramda';
import $ from 'jquery';
import React from 'react';
import Promise from 'bluebird';
import Modal from 'react-bootstrap/lib/Modal';
import Alert from 'react-bootstrap/lib/Alert';
import autoBind from '../../modules/autoBind';
import { validations } from 'common';
import Spinner from '../../modules/Spinner.jsx';
import Table from './Table.jsx';
import CreateUserForm from './CreateUserForm.jsx';
import EditUserForm from './EditUserForm.jsx';
import UserDetails from './UserDetails.jsx';
import Pagination from 'react-bootstrap/lib/Pagination';
import FilterControls from './FilterControls.jsx';

const pageSize = 20;
const columns = [
  { id: 'id', label: 'ID', maxWidth: 1 },
  { id: 'name', label: 'Nombre', maxWidth: 4 },
  { id: 'company', label: 'Compañía', maxWidth: 4 },
  { id: 'age', label: 'Edad', maxWidth: 1 },
  { id: 'sex', label: 'Sexo', maxWidth: 1 },
  { id: 'expiration', label: 'Fecha de Expiración', maxWidth: 2 },
  { id: 'status', label: 'Estatus Cuestionarios', maxWidth: 2 },
  { id: 'completionDate', label: 'Fecha de Respuesta', maxWidth: 2 },
  { id: 'email', label: 'Email', maxWidth: 4 },
  { id: 'consultant', label: 'Consultor', maxWidth: 3 },
];

export default class Users extends React.Component {
  constructor(props) {
    super(props);
        
    autoBind(this);
    this.state = {
      creatingUser: false,
      deletingUser: false,
      editingUser: false,
      filters: {
        name: '',
        company: '',
        email: '',
        sex: ''
      },
      sortColumn: 'id',
      sortOrder: 'asc',
      showingFilters: false,
      selectedRow: null,
      page: 0,
      usersResource: null
    };
  }
  componentDidMount() {
    this.fetchUsers(this.props.resourceUrl);
  }
  static getQuestionnaireStatus(stage) {
    return R.prop(stage, ['No iniciado', 'Datos Personales', 'Cuestionario 1', 'Cuestionario 2', 'Completado']);
  }
  render() {
    if (!this.state.usersResource && this.state.loadingUsers) {
      return <Spinner />;
    }
    if (!this.state.usersResource && !this.state.loadingUsers) {
      return <div>{this.state.errorMessage}</div>;
    }

    const resource = this.state.usersResource;
    const numOfPages = Math.ceil(resource.total / pageSize);
    const usersIndices = R.range(this.state.page * pageSize, (this.state.page + 1) * pageSize);
    const selectedIndex = this.state.selectedRow ? this.state.selectedRow.index : null;
    let count = this.state.page * pageSize;
    const data = this.state.loadingUsers ? [] : usersIndices
    .map(R.compose(R.prop(R.__, resource._embedded)))
    .filter(R.identity)
    .map(({ id, name, company, age, sex, questionnaire, email, consultant }) =>
      ({ id, name, company, age, sex, email, consultant,
        expiration: questionnaire.expirationDate ? moment(questionnaire.expirationDate).format('DD/MM/YYYY') : '-',
        completionDate: questionnaire.completionDate ? moment(questionnaire.completionDate).format('DD/MM/YYYY') : '-',
        status: Users.getQuestionnaireStatus(questionnaire.stage)
      }));

    return (
      <div style={this.state.loadingUsers ? { cursor: 'progress' } : {}}>
        <button type='button' className='btn btn-success' style={{ marginRight: '10px' }} onClick={this.handleOpenCreateUserModal}>Crear Cliente</button>
        <button className='btn btn-default' style={{ marginRight: '10px' }} onClick={() => this.setState({ showingFilters: !this.state.showingFilters })}>Filtrar Clientes</button>
        <If condition={this.state.selectedRow !== null}>
          <button type='button' className='btn btn-info'  style={{ marginRight: '10px' }} onClick={() => window.location.hash = `/clientes/${this.state.selectedRow.row.id}`}>Ver Detalles</button>
        </If>
        <If condition={this.state.selectedRow !== null}>
          <button type='button' className='btn btn-info'  style={{ marginRight: '10px' }} onClick={this.handleOpenEditUserModal}>Editar Cliente</button>
        </If>
        <If condition={this.state.selectedRow !== null && this.props.userType == 'admin'}>
          <button type='button' className='btn btn-info' style={{ marginRight: '10px' }} onClick={this.sendBenziger}>Enviar Benziger</button>
        </If>
        <button type='button' className='btn btn-info' style={{ marginRight: '10px' }} onClick={this.exportUsers}>Exportar Clientes</button>
        <If condition={this.state.selectedRow !== null}>
          <button type='button' className='btn btn-danger' style={{ marginRight: '10px' }} onClick={this.handleOpenDeleteUserModal}>Eliminar Cliente</button>
        </If>
        <If condition={this.state.newUser} >
          {this.renderCreateUserModal()}
        </If>
        <If condition={this.state.editUser} >
          {this.renderEditUserModal()}
        </If>
        <If condition={this.state.deleteUser} >
          {this.renderDeleteUserModal()}
        </If>
        <If condition={this.state.showingFilters}>
          <FilterControls onSubmit={this.handleFiltersChange}/>
        </If>
        <If condition={resource.total > pageSize}>
          <center>
            <Pagination prev={this.state.page !== 0} next={(this.state.page + 1) * pageSize <= resource.total} first={this.state.page !== 0} last={(this.state.page + 1) * pageSize <= resource.total} bsSize="medium" maxButtons={10} items={Math.ceil(resource.total / pageSize)} activePage={this.state.page + 1} onSelect={this.handlePageChange} />
          </center>
        </If>
        <Table columns={columns} sort={{ column: this.state.sortColumn, order: this.state.sortOrder }} data={data} selectedIndex={selectedIndex} onSort={this.handleSortChange} onRowClick={(event) => this.setState({ selectedRow: event })} onRowDoubleClick={({row}) => window.location.hash = `/clientes/${row.id}`} />
        <If condition={this.state.loadingUsers} >
          <Spinner />
        </If>
        <If condition={resource}>
          <div>Mostrando resultados <b>{Math.min(usersIndices[0] + 1, resource.total)}</b>-<b>{Math.min(usersIndices[usersIndices.length - 1] + 1, resource.total)}</b> de <b>{resource.total}</b> resultado{resource.total !== 1 ? 's' : ''}</div>
        </If>
        <If condition={resource.total > pageSize}>
          <center>
            <Pagination prev={this.state.page !== 0} next={(this.state.page + 1) * pageSize <= resource.total} first={this.state.page !== 0} last={(this.state.page + 1) * pageSize <= resource.total} bsSize="medium" maxButtons={10} items={Math.ceil(resource.total / pageSize)} activePage={this.state.page + 1} onSelect={this.handlePageChange} />
          </center>
        </If>
      </div>
    );
  }
  sendBenziger(){
    fetch(this.props.sendBenziger, {
        method: 'post',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({
          username: this.props.user.user,
          userType: this.props.user.userType,
          id: this.state.selectedRow.row.id,
          email: this.state.selectedRow.row.email,
          name: this.state.selectedRow.row.name
        }),
        responseType: 'json'
      })
    .then(response => response.json())
    .then(response => {
        if(response.code === 200){
          alert('El cuestionario fue enviado con exito.');
        } else {
          alert('Hubo un error, contacta al administrador.');
        }
    }); 
  }
  exportUsers() {
    const filters = this.state.filters;
    const url = this.state.usersResource._rels.export
      .replace('{name}', filters.name || '')
      .replace('{company}', filters.company || '')
      .replace('{sex}', filters.sex || '')
      .replace('{email}', filters.email || '')
      .replace('{stage}', filters.stage || '');
    Promise.resolve($.ajax({ url }))
    .then((x) => {
      var a = $("<a />", {
        href: encodeURI('data:text/csv;charset=utf-8,' + x),
        download:"clientes.csv",
        id: 'download-element'
      });
      $('body').append(a);
      a[0].click();
      $('#download-element').remove();
    })
    .catch(() => alert('Ocurrió un error al exportar los clientes.'));
  }
  renderCreateUserModal() {
    const closeModal = () => this.setState({ newUser: null, modalErrorMessage: null })
    const userValidations = R.pick(['email'], validations);
    const validUserForm = () => R.is(Object, this.state.newUser) && validations.validateObject(userValidations, this.state.newUser)
    return (
      <Modal show={true} onHide={closeModal}>
        <Modal.Header closeButton>
          <Modal.Title>Crear Cliente</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <If condition={this.state.modalErrorMessage} >
            <Alert bsStyle="danger" onDismiss={() => this.setState({ modalErrorMessage: null })}>{this.state.modalErrorMessage}</Alert>
          </If>
          <CreateUserForm value={this.state.newUser} onChange={(newUser) => this.setState({ newUser })} />
        </Modal.Body>
        <Modal.Footer>
          <button type='button' className='btn btn-danger' onClick={closeModal}>Cancelar</button>
          <button type='submit' className='btn btn-success' onClick={this.handleCreateUser} disabled={!validUserForm() || this.state.creatingUser}>Crear</button>
        </Modal.Footer>
      </Modal>
    );
  }
  renderEditUserModal() {
    const closeModal = () => this.setState({ editUser: null })
    const userValidations = R.pick(['name', 'company', 'age', 'sex'], validations);
    const validationFields = ['name'];
    if (this.state.editUser.company)
      validationFields.push('company');
    if (this.state.editUser.age)
      validationFields.push('age');
    if (this.state.editUser.sex)
      validationFields.push('sex');
    const user = R.clone(this.state.editUser);
    if (user.age) user.age = parseInt(user.age, 10);
    const validEditForm = () => R.is(Object, this.state.editUser) && validations.validateObject(R.pick(validationFields, validations), user);
    return (
      <Modal show={true} onHide={closeModal}>
        <Modal.Header closeButton>
          <Modal.Title>Editar Cliente</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <EditUserForm value={this.state.editUser} onChange={(editUser) => this.setState({ editUser })} />
        </Modal.Body>
        <Modal.Footer>
          <button type='button' className='btn btn-danger' onClick={closeModal}>Cancelar</button>
          <button type='submit' className='btn btn-success' onClick={this.handleEditUser} disabled={!validEditForm() || this.state.editingUser}>Editar</button>
        </Modal.Footer>
      </Modal>
    );
  }
  renderDeleteUserModal() {
    const closeModal = () => this.setState({ deleteUser: null })
    return (
      <Modal show={true} onHide={closeModal}>
        <Modal.Header closeButton>
          <Modal.Title>Eliminar Cliente</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          ¿Estás seguro de querer eliminar a {this.state.deleteUser.name}?
        </Modal.Body>
        <Modal.Footer>
          <button type='button' className='btn btn-danger' onClick={closeModal}>Cancelar</button>
          <button type='submit' className='btn btn-success' onClick={this.handleDeleteUser} disabled={this.state.deletingUser}>Eliminar</button>
        </Modal.Footer>
      </Modal>
    );
  }
  handleSortChange({ column, order }) {
    const prevColumn = this.state.sortColumn, prevOrder = this.state.sortOrder;
    this.setState({ sortColumn: column, sortOrder: order });
    const url = this.state.usersResource._rels.sort.replace('{sort}', column === 'status' ? 'stage' : column).replace('{order}', order);
    this.fetchUsers(url, this.state.page)
    .catch(() => this.setState({ sortColumn: prevColumn, sortOrder: prevOrder }))
  }
  handleFiltersChange(filters) {
    this.setState({ filters });
    const url = this.state.usersResource._rels.search
      .replace('{name}', filters.name || '')
      .replace('{company}', filters.company || '')
      .replace('{sex}', filters.sex || '')
      .replace('{email}', filters.email || '')
      .replace('{stage}', filters.stage || '')
      .replace('{consultant}', filters.consultant || '');
    this.fetchUsers(url);
  }
  handlePageChange(page) {
    page--; // change to 0 based
    this.fetchUsers(this.state.usersResource._rels.getPage.replace('{pageNum}', page), page);
  }
  fetchUsers(url, page = 0) {
    if (this.state.loadingUsers) {
      return Promise.reject('Already fetching users.');
    }
    const prevPage = this.state.page;
    this.setState({ loadingUsers: true, selectedRow: null, page });
    return Promise.resolve($.ajax({ url }))
    .then((usersResource) => this.setState({ usersResource }))
    .catch(() => this.setState({ page: prevPage, errorMessage: 'Hubo un error al cargar los clientes.' }))
    .finally(() => this.setState({ loadingUsers: false }));
  }
  handleOpenCreateUserModal() {
    this.setState({ newUser: { name: '', email: '', expirationDays: 7, user: this.props.user }});
  }
  handleOpenEditUserModal() {
    this.setState({ editUser: this.state.selectedRow.row });
  }
  handleOpenDeleteUserModal() {
    this.setState({ deleteUser: this.state.selectedRow.row });
  }
  handleCreateUser(event) {
    event.preventDefault();
    this.setState({ creatingUser: true });
    return Promise.resolve($.ajax({
      url: this.props.resourceUrl,
      method: 'POST',
      data: this.state.newUser
    })).then(() => {
      this.setState({ newUser: null, modalErrorMessage: null });
      this.fetchUsers(this.state.usersResource._rels.self, this.state.page);
    }).catch(() => this.setState({ modalErrorMessage: 'Hubo un error al crear el cliente.' }))
    .finally(() => this.setState({ creatingUser: false }));
  }
  handleDeleteUser(event) {
    event.preventDefault();
    this.setState({ deletingUser: true });
     
    const url = this.state.usersResource._rels[this.state.selectedRow.index + pageSize * this.state.page];
    return Promise.resolve($.ajax({
      url: url,
      method: 'DELETE',
    })).then(() => {
      this.setState({ deleteUser: null });
      this.fetchUsers(this.state.usersResource._rels.self, this.state.page);
    }).finally(() => this.setState({ deletingUser: false }));
  }
  handleEditUser(event) {
    event.preventDefault();
    this.setState({ editingUser: true });
    const url = this.state.usersResource._rels[this.state.selectedRow.index];
    return Promise.resolve($.ajax({
      url: url,
      method: 'PUT',
      data: this.state.editUser,
    })).then(() => {
      this.setState({ editUser: null });
      this.fetchUsers(this.state.usersResource._rels.self, this.state.page);
    }).finally(() => this.setState({ editingUser: false }));
  }
}



// WEBPACK FOOTER //
// ./src/App/users/Users.jsx